






































































import Vue from "vue";
import StatusLine from "./StatusLine.vue";
import { Header } from "../MyTable.vue";
import { axios } from "../../plugins";

const stepOption = [
  { label: "10分钟", value: "10m" },
  { label: "30分钟", value: "30m" },
  { label: "1小时", value: "1h" },
  { label: "1天", value: "24h" }
];

function toFixed(value: number, index = 2) {
  if (!value && value !== 0) return "";
  return value.toFixed(index).replace(".".padEnd(index + 1, "0"), "");
}

const monitor = [
  {
    title: "库大小(MB)",
    type: "etcd_mvcc_db_size{(node)}",
    format: (value: string) => toFixed(parseFloat(value) / 1024 / 1024)
  },
  {
    title: "客户端流量(KB/s)",
    type:
      "{__name__=~'(etcd_network_client_grpc_received_bytes|etcd_network_client_grpc_sent_bytes)',(node)}",
    legend: true,
    format: (value: string) => toFixed(parseFloat(value) / 1024)
  },
  {
    title: "gRPC流式消息(次/s)",
    type:
      "{__name__=~'(etcd_grpc_server_msg_received_rate|etcd_grpc_server_msg_sent_rate)',(node)}",
    legend: true
  },
  {
    title: "WAL日志同步时间(ms)",
    type: "etcd_disk_wal_fsync_duration_quantile{(node)}",
    format: (value: string) => toFixed(parseFloat(value) * 1000)
  },
  {
    title: "库同步时间(ms)",
    type: "etcd_disk_backend_commit_duration{(node)}",
    format: (value: string) => toFixed(parseFloat(value) * 1000)
  },
  {
    title: "Raft(次/s)",
    type:
      "{__name__=~'(etcd_server_proposals_failed_rate|etcd_server_proposals_applied_rate|etcd_server_proposals_committed_rate|etcd_server_proposals_pending_count)',(node)}",
    legend: true,
    format: (value: string) => toFixed(parseFloat(value))
  }
];

const tableheader: Header[] = [
  { title: "名称" },
  { title: "主机IP" },
  { title: "是否为Leader" },
  { title: "是否有Leader" },
  { title: "Leader变更次数" }
];
export default Vue.extend({
  name: "CluEtcd",
  components: { StatusLine },
  data() {
    return {
      date: [] as Array<Date>,
      tableheader,
      tableData: [] as Array<any>,
      step: "10m",
      stepOption,
      monitor: monitor,
      node: ""
    };
  },
  mounted() {
    this.init();
    this.getNode();
  },
  methods: {
    init() {
      const start = new Date();
      const end = new Date();

      start.setTime(start.getTime() - 3600 * 1000 * 2);
      // 默认选中 近两小时
      this.date = [start, end];
    },
    getData() {
      this.$nextTick(() => {
        (this.$refs.line as Vue[]).forEach(line => {
          (line as any).getData();
        });
      });
    },
    getNode() {
      axios.get("/metrics/admin/etcd").then(res => {
        this.tableData = res.data.data;
        this.node = this.tableData[0].nodeIp;
        this.setMonitor(this.node);
      });
    },
    setMonitor(ip: string) {
      const Arr: any[] = [];
      monitor.forEach(m => {
        Arr.push({
          ...m,
          type: encodeURIComponent(m.type.replace(/\(node\)/g, `node="${ip}"`))
        });
      });
      this.monitor = Arr;
      this.getData();
    },
    getDefaultData() {
      const now = new Date().getTime();
      switch (this.step) {
        case "10m":
          this.$set(this, "date", [
            new Date(now - 12 * 3600 * 1000),
            new Date(now)
          ]);
          break;
        case "30m":
          this.$set(this, "date", [
            new Date(now - 24 * 3600 * 1000),
            new Date(now)
          ]);
          break;
        case "1h":
          this.$set(this, "date", [
            new Date(now - 48 * 3600 * 1000),
            new Date(now)
          ]);
          break;
        case "24h":
          this.$set(this, "date", [
            new Date(now - 24 * 7 * 3600 * 1000),
            new Date(now)
          ]);
          break;
      }
      this.getData();
    }
  }
});
